import { defineNuxtRouteMiddleware } from '#app'
import { BASE_METHOD, fetchApi } from '~/common/API/baseApi'
import PlaceService from '~/services/PlaceService'

export default defineNuxtRouteMiddleware(async (to) => {
  // Пропускаем статические файлы из папки public (включая /pdf/)
  // Проверяем все возможные расширения статических файлов
  const staticFileExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.svg', '.webp', '.ico', '.css', '.js', '.json', '.xml', '.txt', '.webm', '.mp4', '.mp3', '.zip', '.rar', '.woff', '.woff2', '.ttf', '.otf']
  const hasFileExtension = staticFileExtensions.some(ext => to.path.toLowerCase().endsWith(ext))
  
  if (hasFileExtension) {
    // Для статических файлов не обрабатываем через middleware
    // Они должны обслуживаться напрямую сервером
    return
  }
  
  const path = to.path.split('/')[1] // Получаем первый сегмент пути
  
  // Проверяем существование страницы
  const pages = ['adv', 'advertiser', 'group', 'news', 'balance', 'creatives', 'deposit', 'login', 'max']
  
  if (pages.includes(path)) {
    return
  }
  
  // Если страница не существует, проверяем наличие ID
  const id = to.params.id
  if (id) {
    try {
      const response = await PlaceService.getPlace(id as string)
      return
    } catch (error) {
      throw createError({
        statusCode: 404,
        message: 'Страница не найдена'
      })
    }
  }
  
  // Если ни страница, ни ID не найдены, выбрасываем ошибку
  throw createError({
    statusCode: 404,
    message: 'Страница не найдена'
  })
}) 